import {  createSlice } from "@reduxjs/toolkit";
import {  stateEnum } from "../constants/enum"
const { paymentEntry } = stateEnum
const initialState = {
    detailParams: {},
    isNewEntry: false,
    payVouDetail: [],
    impExpDetailParams:{},
    impExpIsNewEntry:false,
    isRediOutstanding:false
}

// export const setEntryDetail = createAsyncThunk("getEntryDetail",
//     async ({ token, transactionid, compcode, pacid, voutype, db_user }) => {
//         try {
//             const { data } = await customAPI.post(
//                 apiRoute.receiveEntry.fetchEntryDetail, {
//                 transaction_id: transactionid,
//                 comp_code: compcode,
//                 pac_id: pacid,
//                 vou_type: voutype,
//                 db_user: db_user
//             },
//                 {
//                     headers: {
//                         Authorization: "Bearer " + token,
//                     },
//                 }
//             )
//             return data.data
//         }
//         catch (error) {
//             toast.error("Data not found", {
//                 position: "top-center"
//             })
//             console.log(error)
//         }

//     }

// )

const paymentEntrySlice = createSlice({
    name: paymentEntry,
    initialState,
    reducers: {
        resetPayDetailParams: (state) => {
            state.detailParams = {}
            state.isNewEntry = true
        },
        setPayDetailParams: (state, action) => {
            state.detailParams = action.payload
        },
        setPayNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload
        },
        setPayVouReportDetail: (state, action) => {
            state.payVouDetail = [action.payload]
        },
        resetPayVouDetail: (state, action) => {
            state.payVouDetail = []
        },
        setIsRediOutstanding: (state, action) => {
            state.isRediOutstanding = action.payload
        },
        setImpExpDetailParams: (state, action) => {
            state.impExpDetailParams = action.payload
        },
        setImpExpNewEntryMode: (state, action) => {
            state.impExpIsNewEntry = action.payload
        },
         resetImpExpDetailParams: (state) => {
            state.impExpDetailParams = {}
            state.impExpIsNewEntry =true
        },
       

    },
})

export const { resetPayDetailParams,setIsRediOutstanding, setPayNewEntryMode, setPayVouReportDetail, resetPayVouDetail, setPayDetailParams 
    ,setImpExpDetailParams,setImpExpNewEntryMode,resetImpExpDetailParams
} = paymentEntrySlice.actions

export default paymentEntrySlice.reducer

